export default {
  default: () => import("/home/mycrashbaggage/webapps/mycrashbaggage/layouts/default.vue").then(m => m.default || m)
}